import { createFileRoute } from "@tanstack/react-router";
import { Step2LegalCompliance } from "@/features/vendor/onboarding/v1/step-2-legal-compliance";

export const Route = createFileRoute(
  "/vendors/onboarding/v1/step-2-legal-compliance",
)({
  component: Step2LegalCompliance,
});
